import type { App } from 'vue';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

/**
 * Toast notification provider configuration
 * Uses vue-toastification for displaying toast messages
 */
export function setupToast(app: App) {
  app.use(Toast, {
    timeout: 4000,
    closeButton: true,
    position: POSITION.BOTTOM_CENTER,
    shareAppContext: true,
  });
}
